<template>
  <div class="customers">
    <div class="bg">
      <div class="container">
        <p class="title">购买人列表</p>
        <div class="listInfos">
          <div class="top">
            <span class="item">头像</span>
            <span class="item">昵称</span>
            <span class="item">ID</span>
          </div>
          <div class="info">
            <ul class="uls">
              <template v-for="(item,index) in userList">
                <li class="lis" v-if="userList!==null" :key="index">
                  <span class="span">
                    <div class="img">
                      <img :src="item.avatar" alt>
                    </div>
                  </span>
                  <span class="span">{{item.name}}</span>
                  <span class="span">{{item.id}}</span>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      userList: ""
    };
  },
  created() {
    document.getElementsByTagName("title")[0].innerText = "我是谜520表白商店";
    // console.log(this.$route);
    this.getCustomer();
  },
  methods: {
    getCustomer() {
      axios
        .post(this.$interfaces.getUserShopConsumerList, {
          userGuid: this.$store.state.userguid,
          token: this.$store.state.token,
          goodsId: this.$route.query.id
        })
        .then(res => {
          // console.log(res);
          this.userList = res.data.data.userList;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
.customers {
  width: 100%;
  height: 100%;
}
.customers .bg {
  background: url("../../../assets/images/active/bg/buylist.png") no-repeat left
    top;
  background-size: cover;
  height: 33.35rem;
  position: relative;
  text-align: center;
  display: flex;
  justify-content: center;
}
.customers .bg .container {
  width: 16rem;
}
.customers .bg .container .title {
  margin-top: 0.8rem;
  text-align: center;
  font-size: 0.95rem;
  font-family: SourceHanSansCN-Bold;
  font-weight: bold;
  color: rgba(255, 57, 113, 1);
  margin-bottom: 0.5rem;
}
.customers .bg .container .listInfos {
  /* height: 31.15rem; */
  width: 16rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.5rem;
}
.customers .bg .container .listInfos .info {
  width: 16rem;
  border-top: 0.025rem solid #ccc;
}
.customers .bg .container .listInfos .info .lis {
  height: 3rem;
  width: 16rem;
  display: flex;
}
.customers .bg .container .listInfos .info .lis .span {
  width: 33.33%;
  height: 3rem;
  line-height: 3rem;
  text-align: center;
  font-size: 0.75rem;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(255, 64, 117, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.customers .bg .container .listInfos .info .lis .span .img {
  vertical-align: middle;
  text-align: center;
  width: 1.7rem;
  height: 1.7rem;
  /* border:0.025rem solid #ccc; */
  border-radius: 50%;
  overflow: hidden;
}
.customers .bg .container .listInfos .info .lis .span .img img {
  width: 100%;
  height: 100%;
}
.customers .bg .container .listInfos .top {
  height: 3rem;
  width: 16rem;
  display: flex;
}
.customers .bg .container .listInfos .top .item {
  width: 33.33%;
  height: 3rem;
  line-height: 3rem;
  text-align: center;
  font-size: 0.75rem;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(255, 64, 117, 1);
}
</style>





// WEBPACK FOOTER //
// src/components/active/view/customer.vue